import React from 'react';
import themeable from 'zignal-landscape/lib/themeable';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import DateRangePicker from 'zignal-landscape/lib/DateRangePicker';
import { Dark } from 'themes';

const MfeDateRangePicker = (props) => {
  return (
    <ThemeProvider theme={Dark}>
      <DateRangePicker {...props} mfeMode />
    </ThemeProvider>
  );
};

export default themeable(MfeDateRangePicker);
